import { Socket, LongPoll } from 'phoenix'
import SocketChannel from '@App/Lib/SocketChannel'

export let socket = null
export let canalContato = null
export let presenceContato = null
let otherChannels = []
let latestContactId = null
let connectedDepartments = {}

export function abrirConexãoWebsocket(endpoint, contato, store) {
    if (socket) {
        if (latestContactId != contato.id && canalContato) {
            canalContato.leave()
            presenceContato.leave()
            return new Promise(resolve => {
                canalContato.channelName = 'crm_contacts:' + contato.id
                canalContato.connect(socket, resolve)

                joinPresence(socket, contato)
            })
        } else {
            return Promise.resolve()
        }
    }

    latestContactId = contato.id

    return new Promise(resolve => {
        socket = new Socket(endpoint + '/socket', {
            transport: location.href.indexOf('longpoll') !== -1 ? LongPoll : undefined,
            params: { canal: 'anonymous_contact', user_agent: navigator.userAgent, language: navigator.language },
        })

        let firstOpen = true
        socket.onOpen(async () => {
            store.commit('updateWebsocketConnectionStatus', 'on')

            if (!firstOpen) {
                setTimeout(() => {
                    canalContato.replayEvents()
                    otherChannels.forEach(c => c.replayEvents())
                }, 500)
            }

            firstOpen = false
        })

        socket.onClose(() => {
            store.commit('updateWebsocketConnectionStatus', 'off')
        })

        socket.onError(() => {
            socket.transport = LongPoll
        })

        socket.connect()

        joinContact(endpoint, store, contato, resolve)
    })
}

function joinContact(endpoint, store, contato, callback) {
    joinPresence(socket, contato)

    canalContato = new SocketChannel('crm_contacts:' + contato.id)
    canalContato.connect(socket, callback)

    canalContato.on('chat:novo_evento', data => {
        store.dispatch('novoEventoRecebido', data)
    })

    canalContato.on('chat:sync_events', data => {
        store.commit('mesclarEventosDaSala', data)
        if (!data.referência) {
            document.dispatchEvent(
                new CustomEvent('chat:scroll-to-bottom', { detail: { id_sala: data.id_sala, force: true } })
            )
        }
    })

    canalContato.on('chat:atualizar_ack', data => {
        store.commit('atualizarAck', data)
    })

    canalContato.on('chat:update_room', data => {
        store.commit('updateChatRoom', data.room)
    })

    canalContato.on('chat:confirmação_de_envio', data => {
        store.dispatch('confirmarEnvioDeMensagem', data)
    })

    canalContato.on('chat:update_event', data => {
        store.commit('updateEvent', data.event)
    })

    canalContato.on('chat:decrement_queue_position', data => {
        store.commit('decrementQueuePosition', data)
    })

    canalContato.on('chat:increment_queue_position', data => {
        console.log('[Discard event] Increment queue position')
    })

    canalContato.on('crm_contacts:merged', contact => {
        store.commit('updateContact', contact)
        abrirConexãoWebsocket(endpoint, contact, store)
    })

    canalContato.channel.on('chat:digitando', dados => {
        store.dispatch('updateFlashTyping', {
            key: dados.mensageiro_type + ':' + dados.mensageiro_id,
            data: dados,
        })
    })
}

function joinPresence(socket, contato) {
    let presenceChannel = 'presence:crm_contacts:' + contato.id
    console.log('Me juntando ao presence channel', presenceChannel)

    presenceContato = socket.channel('presence:crm_contacts:' + contato.id)
    presenceContato
        .join()
        .receive('ok', () => {
            console.log('me juntei ao presence: ' + presenceChannel)
        })
        .receive('error', res => {
            console.log('Não foi possível se juntar ao presence do contato: ' + res)
        })
}

export function ensureConnectedToDepartment(store, departmentId) {
    if (connectedDepartments[departmentId]) return
    connectedDepartments[departmentId] = true

    let departmentChannel = new SocketChannel('core_departments:' + departmentId)
    departmentChannel.delegateCallbacks(canalContato)
    departmentChannel.connect(socket)
    otherChannels.push(departmentChannel)
}

/**
 * Envia um evento pelo canal do usuário e resolve a promessa com a resposta do servidor.
 *
 * @param {string} evento
 * @param {*} dados
 */
export function fastlane(evento, dados, opts = {}) {
    if (!canalContato) return null
    return canalContato.fastlane(evento, dados, opts)
}
